import { render, staticRenderFns } from "./LecturesAndCreditClassEchartBar.vue?vue&type=template&id=67490d0e&"
import script from "./LecturesAndCreditClassEchartBar.vue?vue&type=script&lang=js&"
export * from "./LecturesAndCreditClassEchartBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports